import Seo from "@/components/feature/Seo";
import Container from "@/components/base/Container";
import PageHero from "@/components/base/PageHero";
import SectionHeading from "@/components/base/SectionHeading";
import TrabajaWizard from "./components/TrabajaWizard";
import { BeneficiosSection, ParticipantesSection, ProcesoSection } from "./components/Sections";

export default function TrabajaConNosotros() {
  return (
    <>
      <Seo
        title="Trabaja con nosotros"
        description="Forma parte de la red de transporte de Axonia Group. Registra tu vehículo o empresa de transporte y presenta tu flota para evaluación."
        path="/trabaja-con-nosotros"
      />
      <PageHero
        title="Trabaja con nosotros"
        subtitle="Pon tu vehículo o tu flota a disposición de AXONIA GROUP."
        crumbs={[{ label: "Inicio", to: "/" }, { label: "Trabaja con nosotros" }]}
        image="https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20several%20white%20cargo%20trucks%20and%20vans%20parked%20in%20a%20clean%20logistics%20yard%20at%20blue%20hour%2C%20professional%20corporate%20transport%20photography%2C%20deep%20ocean%20blue%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1920&height=700&seq=axonia-trabaja-hero&orientation=landscape"
      />

      <section className="bg-background-50 py-12 md:py-16">
        <Container>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.7fr_1fr] lg:gap-10">
            <div>
              <SectionHeading
                eyebrow="Registro de afiliación"
                title="Registra tu vehículo o tu empresa de transporte"
                description="Completa el formulario paso a paso. Puedes registrar varios vehículos. Al finalizar recibirás un número de solicitud y la revisaremos para continuar el proceso."
              />
              <div className="mt-8">
                <TrabajaWizard />
              </div>
            </div>

            <aside className="flex flex-col gap-6">
              <div className="rounded-lg border border-background-200 bg-background-100 p-6">
                <h2 className="text-base font-heading font-semibold text-foreground-950">
                  Información importante
                </h2>
                <ul className="mt-4 space-y-4">
                  <li className="flex gap-3">
                    <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                      <i className="ri-file-list-3-line text-base leading-none" aria-hidden="true"></i>
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-600">
                      Este es un <strong>registro de afiliación</strong>, no una solicitud de servicio.
                      Es una solicitud para formar parte de la red de colaboradores.
                    </p>
                  </li>
                  <li className="flex gap-3">
                    <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                      <i className="ri-shield-check-line text-base leading-none" aria-hidden="true"></i>
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-600">
                      La aprobación y activación se realizan bajo <strong>revisión administrativa</strong>.
                    </p>
                  </li>
                  <li className="flex gap-3">
                    <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                      <i className="ri-lock-line text-base leading-none" aria-hidden="true"></i>
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-600">
                      Tus datos y documentos son <strong>privados</strong> y nunca se muestran en el sitio
                      público.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="rounded-lg border border-accent-300 bg-accent-50 p-6">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-question-answer-line text-lg leading-none" aria-hidden="true"></i>
                </span>
                <h2 className="mt-3 text-sm font-heading font-semibold text-accent-900">
                  ¿Tienes dudas antes de registrarte?
                </h2>
                <p className="mt-1.5 text-xs leading-relaxed text-accent-900">
                  Escríbenos y con gusto te explicamos el proceso de afiliación paso a paso.
                </p>
                <a
                  href="/contacto"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-label font-semibold text-accent-900 transition-colors hover:text-primary-700"
                >
                  Ir a contacto
                  <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
                </a>
              </div>
            </aside>
          </div>
        </Container>
      </section>

      <ParticipantesSection />
      <ProcesoSection />
      <BeneficiosSection />
    </>
  );
}